module.exports = __webpack_public_path__ + "img/icon-replay-light.6a0a371a.svg";